const pageName = 'cartPage';
const clickEvents = {
  // click on the management button
  manageCart_btn: {
    pageName,
    buttonName: 'manageCart'
  },
  // click on the DOTD tab
  filterDOTD_btn: {
    pageName,
    buttonName: 'filterDOTD'
  },
  // click on the priceDrop tab
  filterPriceDrop_btn: {
    pageName,
    buttonName: 'filterPriceDrop'
  },
  // click on the out of stock tab
  filterOutOfStock_btn: {
    pageName,
    buttonName: 'filterOutOfStock'
  },
  // click on the go to pay button
  checkout_btn: {
    pageName,
    buttonName: 'checkout'
  },
  // Go to the recommended asins list and add new items to cart for getting free shipping
  getFreeShipping_btn: {
    pageName,
    buttonName: 'getFreeShipping'
  },
  // click to select another item
  addAnotherVariant_btn: {
    pageName,
    buttonName: 'addAnotherVariant'
  },
  // click remove product button from cart
  removeFromCart_btn: {
    pageName,
    buttonName: 'removeFromCart'
  },
  // click share product
  shareProductInCart_btn: {
    pageName,
    buttonName: 'shareProductInCart'
  },
  // go to product detail page
  goToProductDetail_btn: {
    pageName,
    buttonName: 'goToProductDetail'
  }
};
const loadingEvents = {
  cartPage: {
    pageName: 'cartPage',
    eventName: 'ATF'
  }
};

const businessEvent = {};

export default {
  clickEvents,
  loadingEvents,
  businessEvent
};
